import { render, staticRenderFns } from "./CerrarSorteoManual.vue?vue&type=template&id=681c7a8d&scoped=true&dark=true"
import script from "./CerrarSorteoManual.vue?vue&type=script&lang=js"
export * from "./CerrarSorteoManual.vue?vue&type=script&lang=js"
import style0 from "./CerrarSorteoManual.vue?vue&type=style&index=0&id=681c7a8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681c7a8d",
  null
  
)

export default component.exports